export enum EditMode {
  Update = "update",
  NewVersion = "new-version"
}

export interface NextVersionInfo {
  nextVersionNumber: number;
  suggestedVersionName: string;
  existingVersionNames: string[];
  /**
   * How many versions the mapping has. Reported separately from `existingVersionNames`, which
   * drops falsy names and so undercounts legacy versions created before `versionName` existed.
   */
  versionCount: number;
}

export interface MappingVersionSummary {
  _id: string;
  versionNumber: number;
  versionName: string;
  isDefault: boolean;
  isCalculated: boolean;
}

export interface EditMappingResult {
  mode: EditMode;
  version: MappingVersionSummary | null;
}

export interface EditMappingPayload {
  drawingToolId: string;
  ownerId: string;
  sourceId: string;
  mappingType: number;
  reason: string;
  mode: EditMode;
  versionName?: string;
}

export interface EditMappingFormValues {
  reason: string;
  mode: EditMode;
  versionName: string;
}
